module.exports = __webpack_public_path__ + "static/img/gongzhonghao.f813b6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gongzhonghao.jpg
// module id = mB2L
// module chunks = 20